/**
 * SkeletonThemeProvider
 * ---------------------
 * Wraps react-loading-skeleton's <SkeletonTheme> and derives colors
 * directly from the active CSS variables so every skeleton automatically
 * matches the current app theme (indigo / dark / emerald / sky / rose / violet).
 *
 * Place this once, just inside <ThemeProvider> in App.js.
 */
import React, { useMemo } from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useTheme } from '../../context/ThemeContext';
import { getSkeletonColors, SKELETON_DURATION } from './constants/skeletonTheme';

export default function SkeletonThemeProvider({ children }) {
    // Re-derive colors whenever the theme token changes
    const { theme } = useTheme();

    const { baseColor, highlightColor } = useMemo(
        () => getSkeletonColors(theme),
        [theme]
    );

    return (
        <SkeletonTheme
            baseColor={baseColor}
            highlightColor={highlightColor}
            duration={SKELETON_DURATION}
            borderRadius="8px"
        >
            {children}
        </SkeletonTheme>
    );
}
